var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "ul",
    { staticClass: "list-unstyled", staticStyle: { "line-height": "2rem" } },
    [
      _c(
        "li",
        [
          _c(
            "router-link",
            {
              staticClass: "sidenav-item",
              attrs: { to: "/user/edit", activeClass: "sidenav-active" }
            },
            [
              _c("i", { staticClass: "fal fa-user" }),
              _vm._v(
                " " + _vm._s(_vm.$t("message.menu.edit_profile")) + "\n      "
              )
            ]
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "li",
        [
          _c(
            "router-link",
            {
              staticClass: "sidenav-item",
              attrs: { to: "/user/listings", activeClass: "sidenav-active" }
            },
            [
              _c("i", { staticClass: "fal fa-home" }),
              _vm._v(
                " " + _vm._s(_vm.$t("message.menu.my_listings")) + "\n      "
              )
            ]
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "li",
        [
          _c(
            "router-link",
            {
              staticClass: "sidenav-item",
              attrs: {
                to: "/user/company-address",
                activeClass: "sidenav-active"
              }
            },
            [
              _c("i", { staticClass: "fal fa-building" }),
              _vm._v(
                " " +
                  _vm._s(_vm.$t("message.menu.company_address")) +
                  "\n      "
              )
            ]
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "li",
        [
          _c(
            "router-link",
            {
              staticClass: "sidenav-item",
              attrs: { to: "/user/payment", activeClass: "sidenav-active" }
            },
            [
              _c("i", { staticClass: "fal fa-credit-card" }),
              _vm._v(
                " " + _vm._s(_vm.$t("message.menu.payment_method")) + "\n      "
              )
            ]
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "li",
        [
          _c(
            "router-link",
            {
              staticClass: "sidenav-item",
              attrs: {
                to: "/user/notifications",
                activeClass: "sidenav-active"
              }
            },
            [
              _c("i", { staticClass: "fal fa-bell" }),
              _vm._v(
                " " +
                  _vm._s(_vm.$t("message.menu.notification_settings")) +
                  "\n      "
              )
            ]
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "li",
        [
          _c(
            "router-link",
            {
              staticClass: "sidenav-item",
              attrs: { to: "/user/invite", activeClass: "sidenav-active" }
            },
            [
              _c("i", { staticClass: "fal fa-gift" }),
              _vm._v(
                " " + _vm._s(_vm.$t("message.menu.invite_friends")) + "\n      "
              )
            ]
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "li",
        [
          _c(
            "router-link",
            {
              staticClass: "sidenav-item",
              attrs: { to: "/user/credits", activeClass: "sidenav-active" }
            },
            [
              _c("i", { staticClass: "fal fa-wallet" }),
              _vm._v(
                " " + _vm._s(_vm.$t("message.menu.my_credits")) + "\n      "
              )
            ]
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "li",
        [
          _c(
            "router-link",
            {
              staticClass: "sidenav-item",
              attrs: { to: "/user/my-vouchers", activeClass: "sidenav-active" }
            },
            [
              _c("i", { staticClass: "fal fa-ticket" }),
              _vm._v(
                " " +
                  _vm._s(_vm.$t("message.promo_code.my_vouchers")) +
                  "\n      "
              )
            ]
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "li",
        [
          _c(
            "router-link",
            {
              staticClass: "sidenav-item",
              attrs: {
                to: "/user/personal-data-management",
                activeClass: "sidenav-active"
              }
            },
            [
              _c("i", { staticClass: "fal fa-user-shield" }),
              _vm._v(
                " " +
                  _vm._s(_vm.$t("message.menu.personal_data_management")) +
                  "\n      "
              )
            ]
          )
        ],
        1
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-3c8d0ebc", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3c8d0ebc","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/user/MainMenu.vue
// module id = 1796
// module chunks = 0